module.exports = __webpack_public_path__ + "img/logowhite.584cec73.png";